import { useSSOContext } from "lib/contexts/SSOProvider";

export const PostLoginButton = ({
  onClick
}: {
  onClick: () => void;
}) => {
  const {
    state: { popup },
  } = useSSOContext();

  return (
    <button
      style={{
        backgroundColor: popup?.postLogin?.primaryCTA.backgroundColor,
        color: popup?.postLogin?.primaryCTA.color,
      }}
      className="w-full min-h-[40px] text-center font-medium text-base rounded-xl mt-8 mb-4"
      onClick={onClick}
    >
      {popup?.postLogin?.primaryCTA.text}
    </button>
  );
};
